import React, { Component } from 'react';
import moment from 'moment';
import { Link, withRouter } from 'react-router-dom';
import Modal from 'react-modal';
import IosAdd from 'react-ionicons/lib/IosAdd';
import IosTrashOutline from 'react-ionicons/lib/IosTrashOutline';

import { get, patch } from '../services/api';

import colors from '../utils/colors';
import OrdersList from './OrdersList';
import Button from './Button';
import Loading from './Loading/Loading';

const customStyles = {
  content: {
    height: '70%',
    width: '50%',
    padding: 20,
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)'
  }
};

const parcoursLabels = {
  Postal: 'Code postal',
  Birthdate: 'Date de naissance',
  Status: 'Statut',
  Bac: 'Bac',
  FirstLicense: 'Licence',
  FirstLicensePlace: 'Lieu de la licence',
  ForeignXp: 'Expérience à l\'étranger',
  ChildhoodContact: 'Contact avec des enfants',
  ChildhoodContactText: 'Détails contact enfants',
  Desc: 'Description',
  Hobbies: 'Loisirs',
  Plus: 'Le plus'
};

// Simplified TopicsModal
class TopicsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allTopics: [],
      allLevels: [],
      selectedTopics: props.teacher.tutorSubjectLevels.map(tsl => ({ subjectId: tsl.subjectId, levelId: tsl.levelId })),
      loading: true,
    };
  }

  async componentDidMount() {
    const [topics, levels] = await Promise.all([
      get('/admin/teachers/topics'),
      get('/admin/teachers/levels')
    ]);
    this.setState({ allTopics: topics || [], allLevels: levels || [], loading: false });
  }

  handleTopicChange = (subjectId, levelId) => {
    this.setState(prevState => {
      const isSelected = prevState.selectedTopics.some(t => t.subjectId === subjectId && t.levelId === levelId);
      if (isSelected) {
        return { selectedTopics: prevState.selectedTopics.filter(t => !(t.subjectId === subjectId && t.levelId === levelId)) };
      } else {
        return { selectedTopics: [...prevState.selectedTopics, { subjectId, levelId }] };
      }
    });
  }

  selectAllLevels = (subjectId) => {
    this.setState(prevState => {
      const otherSelectedTopics = prevState.selectedTopics.filter(t => t.subjectId !== subjectId);
      const allTopicLevels = this.state.allLevels.map(l => ({ subjectId, levelId: l.levelId }));
      return { selectedTopics: [...otherSelectedTopics, ...allTopicLevels] };
    });
  }

  saveChanges = async () => {
    const topicsPayload = this.state.selectedTopics.reduce((acc, { subjectId, levelId }) => {
      let topic = acc.find(t => t._id === subjectId);
      if (!topic) {
        topic = { _id: subjectId, levels: [] };
        acc.push(topic);
      }
      topic.levels.push(levelId);
      return acc;
    }, []);

    await patch(`/admin/teachers/${this.props.teacher.email}`, { topics: topicsPayload });
    this.props.closeModal();
  }

  render() {
    const { allTopics, allLevels, selectedTopics, loading } = this.state;
    if (loading) return <Loading />;

    return (
      <div style={{ margin: 50, marginBottom: 20 }}>
        {allTopics.map(topic => (
          <div key={topic.subjectId}>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <h3 style={{ color: '#227', margin: 0 }}>{topic.name}</h3>
              <button
                type="button"
                onClick={() => this.selectAllLevels(topic.subjectId)}
                style={{ marginLeft: 15, padding: '2px 8px', fontSize: 12, border: '1px solid #227', borderRadius: 4, cursor: 'pointer', backgroundColor: '#fdfdfd' }}
              >
                Tout sélectionner
              </button>
            </div>
            <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: 20 }}>
              {allLevels.map(level => {
                const isSelected = selectedTopics.some(t => t.subjectId === topic.subjectId && t.levelId === level.levelId);
                return (
                  <div key={level.levelId} style={{ margin: 5, padding: '5px 10px', border: '1px solid #ccc', borderRadius: 5, cursor: 'pointer', backgroundColor: isSelected ? colors.green : 'white' }}
                    onClick={() => this.handleTopicChange(topic.subjectId, level.levelId)}>
                    {level.name}
                  </div>
                )
              })}
            </div>
          </div>
        ))}
        <div style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'flex-end', marginTop: 50 }}>
          <Button style={{ marginRight: 10 }} type='danger' handleClick={this.props.closeModal} text='Annuler' />
          <Button type='validate' handleClick={this.saveChanges} text='Confirmer' />
        </div>
      </div>
    );
  }
}


class RatesModal extends Component {
  render() {
    return (
      <div>
        {this.props.rates.map(r => (
          <div style={{ display: 'flex', flexDirection: 'row', borderBottom: '1px solid #eee', padding: '10px 0' }} key={r.courseId}>
            <div style={{ flex: 1 }}>
              <p><b>Général: {r.general}/5</b></p>
              <Link style={{ textDecoration: 'none', color: '#227' }} to={`/orders/${r.courseId}`}>Voir le cours</Link>
            </div>
            <div style={{ flex: 2 }}>
              <p>Présentation: {r.presentation}/5</p>
              <p>État d'esprit: {r.mindset}/5</p>
              <p>Patience: {r.patience}/5</p>
              <p>Pédagogie: {r.pedagogy}/5</p>
              {r.text && <p>Précisions: {r.text}</p>}
            </div>
          </div>
        ))}
      </div>
    )
  }
}

class Teacher extends Component {

  constructor(props) {
    super(props);
    this.state = { teacher: null, topicsModal: false, ratesModal: false, newZone: '' }
  }

  componentDidMount() {
    this.fetchTeacher();
  }

  fetchTeacher = async () => {
    const teacher = await get(`/admin/teachers/${this.props.match.params.id}`);
    if (teacher) {
      if (typeof teacher.zones === 'string') {
        try {
          teacher.zones = JSON.parse(teacher.zones);
        } catch (e) {
          console.error('Failed to parse zones', e);
          teacher.zones = [];
        }
      }
      if (typeof teacher.infos === 'string') {
        try {
          teacher.infos = JSON.parse(teacher.infos);
        } catch (e) {
          // Keep as string if parsing fails or if it's already plain text?
          // If validation says it is stringified JSON, then parse it.
        }
      }
    }
    this.setState({ teacher });
  }

  closeModal = () => {
    this.setState({ topicsModal: false });
    this.fetchTeacher();
  }

  togglePictureValidated = async () => {
    await patch(`/admin/teachers/${this.state.teacher.email}`, { pictureValidated: !this.state.teacher.pictureValidated });
    this.fetchTeacher();
  }

  toggleVerified = async () => {
    await patch(`/admin/teachers/${this.state.teacher.email}`, { verified: !this.state.teacher.verified });
    this.fetchTeacher();
  }

  addZone = async () => {
    const { teacher, newZone } = this.state;
    if (newZone.length !== 2) {
      alert('Erreur, Le nouveau département doit comporter 2 caractères');
      return;
    }
    const updatedZones = [...(teacher.zones || []), newZone];
    await patch(`/admin/teachers/${teacher.email}`, { zones: updatedZones });
    this.setState({ newZone: '' });
    this.fetchTeacher();
  }

  removeZone = async (zoneToRemove) => {
    const { teacher } = this.state;
    const updatedZones = teacher.zones.filter(z => z !== zoneToRemove);
    await patch(`/admin/teachers/${teacher.email}`, { zones: updatedZones });
    this.fetchTeacher();
  }

  render() {
    const { teacher, newZone, topicsModal, ratesModal } = this.state;
    if (!teacher) return <Loading />;

    return <div>
      <div style={{ margin: 20 }}>
        {/* Basic Info */}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          {teacher.pictureUrl && (
            <img
              src={teacher.pictureUrl.startsWith('http') ? teacher.pictureUrl : `${process.env.REACT_APP_API_URL}${teacher.pictureUrl}`}
              alt="Profile"
              style={{ width: 80, height: 80, borderRadius: 40, marginRight: 20, objectFit: 'cover' }}
            />
          )}
          <div>
            <h2>{teacher.firstName} {teacher.lastName}</h2>
            <p>{teacher.email}</p>
            <p>{teacher.phone}</p>
          </div>
        </div>
        <p>Inscrit le: {new Date(teacher.createdAt).toLocaleDateString()}</p>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <p>Note moyenne : {teacher.rate !== undefined && teacher.rate !== null ? `${Math.round(teacher.rate * 10) / 10}/5` : 'N/A'}</p>
          {teacher.rates && teacher.rates.length > 0 && <IosAdd fontSize='25px' onClick={() => this.setState({ ratesModal: true })} color={colors.dark_blue} style={{ cursor: 'pointer' }} />}
        </div>

        <div style={{ marginTop: 20, marginBottom: 20 }}>
          <h3>CV</h3>
          {teacher.infos ? (
            typeof teacher.infos === 'string' ? <p style={{ whiteSpace: 'pre-wrap' }}>{teacher.infos}</p> :
              ((teacher.infos.Biographie || teacher.infos.bio) ? <p style={{ whiteSpace: 'pre-wrap' }}>{teacher.infos.Biographie || teacher.infos.bio}</p> : <p>Aucun CV renseigné (JSON sans bio).</p>)
          ) : <p>Aucun CV renseigné.</p>}
        </div>

        <div style={{ marginTop: 20, marginBottom: 20 }}>
          {teacher.infos && typeof teacher.infos === 'object' && Object.keys(parcoursLabels).some(key => teacher.infos[key]) && (
            <div>
              <h3>Parcours du professeur</h3>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '10px' }}>
                {Object.entries(parcoursLabels).map(([key, label]) => {
                  let value = teacher.infos[key];
                  if (!value) return null;

                  if (key === 'Birthdate') {
                    value = moment(value).format('DD/MM/YYYY');
                  }

                  return (
                    <div key={key}>
                      <strong>{label}:</strong> <span style={{ color: '#555' }}>{value}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        </div>

        {/* Validations */}
        <div>
          <label style={{ marginRight: 5 }}>Photo validée</label>
          <input type='checkbox' checked={teacher.pictureValidated} onChange={this.togglePictureValidated} />
        </div>
        <div>
          <label style={{ marginRight: 5 }}>Profil vérifié</label>
          <input type='checkbox' checked={teacher.verified} onChange={this.toggleVerified} />
        </div>

        {/* Zones */}
        <p>Départements :</p>
        <ul>
          {Array.isArray(teacher.zones) && teacher.zones.map(z => (
            <li key={z} style={{ display: 'flex', alignItems: 'center', height: 20 }}>
              <p>{z}</p>
              <div style={{ marginLeft: 5, cursor: 'pointer' }} onClick={() => this.removeZone(z)}>
                <IosTrashOutline color={colors.error} fontSize="15px" />
              </div>
            </li>
          ))}
          <li>
            <input type="text" value={newZone} onChange={(e) => this.setState({ newZone: e.target.value })} placeholder="XX" maxLength="2" style={{ width: '30px' }} />
            <button onClick={this.addZone}>Ajouter</button>
          </li>
        </ul>

        {/* Topics */}
        <div>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <h3 style={{ marginRight: 20 }}>Matières</h3>
            <Button handleClick={() => this.setState({ topicsModal: true })} text='Modifier' />
          </div>
          {teacher.topics?.map(t => (
            <div key={t._id} style={{ marginLeft: 20 }}>
              <p style={{ color: '#227' }}>{t.name}</p>
              <div style={{ display: 'flex', flexDirection: 'row', marginLeft: 30 }}>
                {t.levels.map((l, i) => <p key={i} style={{ margin: 5 }}>{l}</p>)}
              </div>
            </div>
          ))}
        </div>

        {/* Orders */}
        {teacher.orders && <OrdersList orders={teacher.orders} />}
      </div>

      {/* Modals */}
      <Modal isOpen={topicsModal} onRequestClose={this.closeModal} style={customStyles}>
        <h2>Modifier les matières et les niveaux</h2>
        <TopicsModal teacher={teacher} closeModal={this.closeModal} />
      </Modal>
      <Modal isOpen={ratesModal} onRequestClose={() => this.setState({ ratesModal: false })} style={customStyles}>
        <h2>Détails des notes</h2>
        <RatesModal rates={teacher.rates || []} />
      </Modal>
    </div>
  }
}

export default withRouter(Teacher);
